/**
 * @file This file contains the configuration for all street furniture items in the game.
 * @module streetFurnitureConfig
 */

export const streetFurniture = {
    'sf_tokyo_tower': {
        key: 'sf_tokyo_tower',
        display: '🗼',
        name: 'Tokyo Tower',
        type: 'landmark',
        description: 'A famous landmark.',
        style: { backgroundColor: 'transparent' }
    },
    'sf_statue_of_liberty': {
        key: 'sf_statue_of_liberty',
        display: '🗽',
        name: 'Statue of Liberty',
        type: 'landmark',
        description: 'A symbol of freedom.',
        style: { backgroundColor: 'transparent' }
    },
    'sf_church': {
        key: 'sf_church',
        display: '⛪',
        name: 'Church',
        type: 'building',
        description: 'A place of worship.',
        style: { backgroundColor: 'transparent' }
    },
    'sf_mosque': {
        key: 'sf_mosque',
        display: '🕌',
        name: 'Mosque',
        type: 'building',
        description: 'A place of worship.',
        style: { backgroundColor: 'transparent' }
    },
    'sf_hindu_temple': {
        key: 'sf_hindu_temple',
        display: '🛕',
        name: 'Hindu Temple',
        type: 'building',
        description: 'A place of worship.',
        style: { backgroundColor: 'transparent' }
    },
    'sf_synagogue': {
        key: 'sf_synagogue',
        display: '🕍',
        name: 'Synagogue',
        type: 'building',
        description: 'A place of worship.',
        style: { backgroundColor: 'transparent' }
    },
    'sf_shinto_shrine': {
        key: 'sf_shinto_shrine',
        display: '⛩️',
        name: 'Shinto Shrine',
        type: 'building',
        description: 'A traditional gate.',
        style: { backgroundColor: 'transparent' }
    },
    'sf_fountain': {
        key: 'sf_fountain',
        display: '⛲',
        name: 'Fountain',
        type: 'decoration',
        description: 'A decorative water fountain.',
        style: { backgroundColor: 'transparent' }
    }
};